module.exports = __webpack_public_path__ + "img/icon_success@2x.ccf4375a.png";